import { ExternalLink } from "lucide-react";
import { BaseAppointmentAction, AppointmentActionCategory, UserRole, AppointmentActionContext, AppointmentActionPayload, AppointmentActionResult } from "../core/base-action";

export class ViewAppointmentAction extends BaseAppointmentAction {
    readonly config = {
        id: "view_appointment",
        label: "View Appointment",
        description: "Open appointment details page",
        icon: ExternalLink,
        category: AppointmentActionCategory.COMMUNICATION,
        permissions: {
            requiredRole: [UserRole.PMC, UserRole.VENDOR],
            excludedStatuses: []
        },
        requiresDialog: false,
        variant: "default" as const
    };

    validatePayload(payload?: AppointmentActionPayload): string | null {
        return null; // No payload validation needed
    }

    getDialogComponent(): string {
        return "ViewAppointmentDialog";
    }

    async execute(
        context: AppointmentActionContext,
        payload?: AppointmentActionPayload
    ): Promise<AppointmentActionResult> {
        try {
            // Open appointment page in new tab/window
            const appointmentUrl = `/appointments/${context.appointmentId}`;
            window.open(appointmentUrl, '_blank');

            return {
                success: true,
                message: "Opening appointment details"
            };
        } catch (error: any) {
            return {
                success: false,
                message: error.message || "Failed to open appointment"
            };
        }
    }
}